class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
  }

  onPointerEnter(event) {
    if (!this.header || !this.hoverQuery.matches || event.pointerType !== 'mouse') return;
    clearTimeout(this.closeTimer);
    this.header.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onPointerLeave(event) {
    if (!this.hoverQuery.matches || event.pointerType !== 'mouse') return;
    clearTimeout(this.closeTimer);
    // Allow the pointer to cross the small gap into the submenu without collapsing it.
    this.closeTimer = setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 150);
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
  }

  onToggle() {
    if (!this.header) return;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);
    // Toggle events are queued: another menu may have opened before this one closes.
    this.header.preventHide = Array.from(this.header.querySelectorAll('header-menu')).some(
      (menu) => menu.mainDetailsToggle.open
    );

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
